import { TAXDOWN_THEME_NAME } from 'Constants/themes';
import { LOCAL_DOMAIN, DEVELOPMENT_DOMAIN } from 'Constants/domains';

export const getTheme = () => {
  const host = window.location.host.split('.')[0];
  switch (host) {
    default:
      return TAXDOWN_THEME_NAME;
  }
};

export const getBaseUrl = () => {
  const { origin } = window.location;
  const { STAGE, NODE_ENV } = process.env;

  if (STAGE === 'local') {
    return LOCAL_DOMAIN;
  }
  if (NODE_ENV === 'development') {
    return DEVELOPMENT_DOMAIN;
  }
  return `${origin}`;
};

export const getIsMobileBrowser = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
  const isAndroid = /android/i.test(userAgent);
  const isWindowPhone = /windows phone/i.test(userAgent);
  return isSafari || isAndroid || isWindowPhone;
};
